import { render, staticRenderFns } from "./DialogDefaultConfirmarAcao.vue?vue&type=template&id=530b45e8"
import script from "./DialogDefaultConfirmarAcao.vue?vue&type=script&lang=js"
export * from "./DialogDefaultConfirmarAcao.vue?vue&type=script&lang=js"
import style0 from "./DialogDefaultConfirmarAcao.vue?vue&type=style&index=0&id=530b45e8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports